<template>
  <ul>
    <li class="flex items-center">
      <a target="_blank" class="hover:shadow-xl flex items-center" href="https://www.upwork.com/freelancers/~0168de0b094ef0b2a9">
        <img :class="imgClass" src="@/assets/images/social/upwork.png" alt="UpWork Logo">
      </a>
    </li>
    <li v-for="social of social" :key="social.name" class="flex items-center">
      <a target="_blank" v-if="!social.copied" :href="social.url"
       class="flex items-center justify-center" >
         <font-awesome-icon
        :class="[(social.nameLight && !isLight)
        ?'text-'+social.nameLight : 'text-'+social.name, iconClass]"
          :icon="social.icon" />
      </a>
      <div v-else class="flex items-center justify-center tooltip relative">
        <transition name="modal">
          <tool-tip v-show="visible" :text="textTool"></tool-tip>
        </transition>
        <font-awesome-icon :class="['text-'+social.name, iconClass]"
         :icon="social.icon" @click="onCopy(social.text)" />
      </div>
    </li>
  </ul>
</template>
<script>
import ToolTip from '@/components/ToolTip.vue';

export default {
  name: 'SocialSection',
  props: {
    isLight: {
      default: true,
      type: Boolean,
    },
    social: {
      type: Array,
      required: true,
    },
    imgClass: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      textTool: '',
    };
  },
  components: {
    ToolTip,
  },
  methods: {
    onCopy(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.textTool = 'Copied!!';
        })
        .catch((err) => {
          this.textTool = `Something went wrong ${err}`;
        })
        .finally(() => {
          this.visible = true;
          setTimeout(() => {
            this.visible = false;
          }, 2000);
        });
    },
  },
};
</script>
<style scoped>
.button-hover-me{
  top:46%;
  bottom:46%;
  left: 37%;
  right:37%;
  background: rgb(0,0,0,.2);
}

</style>
